import EventEmitter from 'eventemitter3';
import Request from "../../../lib/ajax/request";
import Google from '../../../helpers/google';

export default class PopinFilter extends EventEmitter {

    constructor( opts = {} ) {
        super();

        this._container = opts.container || document.body ;

        this._scrollTick = false;
        this._lastKnownScrollY = 0;

        bindAll(this, [
            '_openPopin',
            '_closePopin',
            '_openSelectFilter',
            '_selectFilters',
            '_deleteFilters',
            '_showResult',
            '_resetOpts',
            '_closeFilterSelect'
        ]);

        this._init();
        this._retrieveDOM();
        this.bind();
        this._getParamsUrl();
        this._initEvents();
    }

    /**
     * Set filter open button visibility
     * @param {Boolean} v value input
     */
    set btnVisible(v) {
        this.views.btnOpenWrapper.classList[v ? 'add': 'remove']('visible')
    }

    /**
     * Get filter open button visibility
     * @return {Boolean}
     */
    get btnVisible() {
        return this.views.btnOpenWrapper.classList.contains('visible');
    }

    _init() {

        this._action = 'candiapro_recipes_filter_ajax';

        this._paramsRecipes = {
            alcoholfree : null,
            flavors : [],
            seasons : [],
            chefs : [],
            products : []
        };
        this._lengthParamsRecipes = Object.keys(this._paramsRecipes).length;

        this._currentURL = null;
        this._urlWithParams = ( window.location.href.split('?')[1] == undefined ) ? false : true;

        this._filterSelectIsOpen = false;
        this._totalRecipes = totalRecipes;
        this._countResult = this._totalRecipes;
        this._containerFilterOptsSelected = null;
    }

    _retrieveDOM() {

        this.views = {};
        
        this.views.recipeList = this._container.querySelector( '.js-recipe-list' );

        this.views.btnOpenWrapper = this._container.querySelector( '.js-btn-popin-filter-wrapper' );
        // TODO: /!\ make classes more precises
        this.views.btnOpenPopin = this._container.querySelector( '.js-btn-open-popin' );
        this.views.btnClosePopin = this._container.querySelector( '.js-btn-close-popin' );
        this.views.popinFilter = this._container.querySelector( '.js-popin-filters' );

        this.views.inputsFilter = [].slice.call( this._container.querySelectorAll( '.js-input-filter' ) );
        this.views.selectFilter = [].slice.call( this._container.querySelectorAll( '.js-search-params-choice' ) );
        this.views.selectFilterTitle = [].slice.call( this._container.querySelectorAll( '.js-choice-title' ) );
        this.views.selectFilterList = [].slice.call( this._container.querySelectorAll( '.js-choice-select-list' ) );
        this.views.selectFilterOptsSelected = [].slice.call( this._container.querySelectorAll( '.js-choice-options-selected' ) );

        this.views.countResult = this._container.querySelector( '.js-label-number' );

        this.views.btnShowResult = this._container.querySelector( '.js-btn-show-result' );

        this.views.btnResetOpts = this._container.querySelector( '.js-btn-options-reset' );

        this.views.footer = document.body.querySelector('.footer');
    }

    bind() {

        this.views.btnOpenPopin.addEventListener( 'click', this._openPopin );

        this.views.btnClosePopin.addEventListener( 'click', this._closePopin );

        for( let i = 0, j = this.views.inputsFilter.length; i < j; i++ ) {
            this.views.inputsFilter[i].addEventListener( 'change', this._selectFilters );
        }

        this.views.btnShowResult.addEventListener( 'click', this._showResult );

        for( let i = 0, j = this.views.selectFilterTitle.length; i < j; i++ ) {
            this.views.selectFilterTitle[i].addEventListener( 'click', this._openSelectFilter );
        }

        this.views.btnResetOpts.addEventListener( 'click', this._resetOpts );

        this.delegateOptsDelete = delegate( this._container, '.js-options-delete', 'click', this._deleteFilters );

        document.body.addEventListener( 'click', this._closeFilterSelect );
    }

    /**
     * Init Popin Events
     * @private
     */
    _initEvents() {
        window.addEventListener('scroll', this._handleScroll.bind(this));
    }

    /**
     * Handle scroll event with raf
     * @param scrollY
     * @private
     */
    _handleScroll(e) {
        this._lastKnownScrollY = window.scrollY;
        if (!this._scrollTick) {
            window.requestAnimationFrame(() => {
                // Call scroll methods here
                this._manageBtnOpenVisibility(this.views.footer, this._lastKnownScrollY, -50);

                this._scrollTick = false;
            });
        }
        this._scrollTick = true;
    }

    /*
       Function "_openPopin"
       Open the filters popin when user click on button "Filters"
   */
    _openPopin( event ) {
        // Modal prevent scroll on mobile only
        if( ENV.template == 'mobile' ) {
            setTimeout( () => {
                document.body.classList.add( 'no-scroll' );
            }, 450 );
        }
        this.views.popinFilter.classList.add( 'show' );
        this.emit( MANAGE_POPIN_FILTER_EVENT.OPEN );
    }

    /*
       Function "_closePopin"
       Close the filters popin when user click on button close
   */
    _closePopin( event ) {
        // Modal prevent scroll on mobile only
        if( ENV.template == 'mobile' ) {
            document.body.classList.remove( 'no-scroll' );
        }
        this.views.popinFilter.classList.remove( 'show' );
        this.emit( MANAGE_POPIN_FILTER_EVENT.CLOSE );
    }

    /**
     * Toggle btn open filter visibility on scroll to an element
     * @param {Node} element - Target when hidding button
     * @param {Number} offset - Scroll visibility offset
     * @private
     */
    _manageBtnOpenVisibility(element, scrollY, offset = 0) {
        if( element ) {
            const elementPositionY = element.getBoundingClientRect().top;
            const btnPositionY = this.views.btnOpenPopin.getBoundingClientRect().top;
            if (elementPositionY <= btnPositionY - offset) {
                this.btnVisible = false;
            } else {
                this.btnVisible = true
            }
        }
    }

    /*
       Function "_selectFilters"
       Called when the user clicks on a filter input (type checkbox)
   */
    _selectFilters( event ) {

        // Get input info
        let target = event.currentTarget;
        let nameFilter = target.name;
        let checkFilter = target.checked;
        let valueFilter = parseInt( target.value );
        let labelFilter = target.getAttribute( 'data-label' );

        // Update the selected parameters
        if( this._paramsRecipes.hasOwnProperty( nameFilter ) ) {

            if ( Array.isArray( this._paramsRecipes[ nameFilter ] ) ) {

                let indexValue = this._paramsRecipes[ nameFilter ].indexOf( valueFilter );

                if( ( indexValue != -1 ) && ( checkFilter == false ) ) {

                    this._paramsRecipes[ nameFilter ].splice( indexValue, 1 );
                    this._removeOptsSelected( nameFilter, valueFilter );

                } else if( ( indexValue == -1 ) && ( checkFilter == true ) ) {

                    this._paramsRecipes[ nameFilter ].push( valueFilter );
                    this._addOptsSelected( labelFilter, nameFilter, valueFilter );

                }

            } else {

                if( checkFilter )
                    this._paramsRecipes[ nameFilter ] = checkFilter;
                else
                    this._paramsRecipes[ nameFilter ] = null;

            }

            this._updateURL();
            this._requestFilter();
        }
    }

    /*
       Function "_updateURL"
       Update the URL of the page according the selected parameters
   */
    _updateURL() {

        let pageURL = window.location.href.split( '?' )[0];
        let paramsURL = '?';

        // Create the url with the different parameters
        for ( let param in this._paramsRecipes ) {

            if ( !this._paramsRecipes.hasOwnProperty( param ) ) continue;

            let filter = this._paramsRecipes[ param ];

            if ( Array.isArray( filter ) ) {

                for ( let value in filter ) {
                    paramsURL += param + '[]=' + filter[ value ] + '&';
                }

            } else {
                if( filter != null )
                    paramsURL += param + '=1&';
            }
        }

        // Delete last char : ? or &
        paramsURL = paramsURL.slice(0, -1);

        pageURL += paramsURL;

        // Get new url with param unless there are no parameters selected or if the url on the initial page does not contain a filter
        if( this._urlWithParams || paramsURL != '' )
            this._currentURL = pageURL;
        else
            this._currentURL = null;
    }

    /*
       Function "_requestFilter"
       Request AJAX to retrieve the number of recipes that matches the filters
   */
    _requestFilter() {
        Request.AJAX({
            'url': '/ajax.php?action=' + this._action,
            'data': this._paramsRecipes,
            'success': this._response.bind(this)
        });
    }

    /*
        Function "_response"
        Called when request is over
        @Params :
            xhr: object => the element returned by the request AJAX
    */
    _response( xhr ) {

        this._countResult = this._totalRecipes;

        if( xhr.success == true ) {
            if( ( xhr.data.hasOwnProperty('has_results') ) && ( xhr.data.has_results === true ) ){
                this._countResult = xhr.data.count_results;
            } else {
                this._countResult = 0;
            }
        }

        this._updateCountResult( this._countResult );
        this._updtateBtnResult();
    }

    /*
        Function "_updateCountResult"
        Called when request is over to display the result number
        @Params :
            countResult: number => update the indication of the number of corresponding recipes
    */
    _updateCountResult( countTotalResult ) {
        this.views.countResult.innerHTML = countTotalResult;
    }

    /*
        Function "_updtateBtnResult"
        Called when request is over to disable the search button or not
    */
    _updtateBtnResult() {
        if( this._countResult != 0 )
            this.views.btnShowResult.classList.remove( 'disabled' );
        else
            this.views.btnShowResult.classList.add( 'disabled' );
    }

    /*
        Function "_showResult"
        Called when the user clicks on the "valid" button of the filters
    */
    _showResult( event ) {
        if( this._currentURL != null && this._countResult != 0 ){
            // Add Push Custom Tracker
            Google.pushCustomTracker('Filter', 'Send');
            for (const key in this._paramsRecipes) {
                if (this._paramsRecipes.hasOwnProperty(key)) {
                    const result = this._paramsRecipes[key];
                    if (result != null && result.length != 0) {
                        for (let i = 0; i < result.length; i++) {
                            Google.pushCustomTracker('Filter', this._container.querySelector('.js-input-filter[value="'+result[i]+'"]').getAttribute('data-label'));
                        }
                    }
                }
            }
            document.location.href = this._currentURL;
        }
    }

    /*
        Function "_openSelectFilter"
        Called when the user clicks on the filter titles to display the list of possibilities
    */
    _openSelectFilter( event ) {

        let target = event.currentTarget;
        let index = this.views.selectFilterTitle.indexOf( target );

        this._containerFilterOptsSelected = null;
        this._filterSelectIsOpen = false;

        for( let i = 0, j = this.views.selectFilter.length; i < j; i++ ) {

            let element = this.views.selectFilter[i];

            if( i == index && element.classList.contains( 'show' ) == false ) {

                element.classList.add( 'show' );
                this._filterSelectIsOpen = true;
                this._containerFilterOptsSelected = this.views.selectFilterOptsSelected[i];

            } else {
                element.classList.remove( 'show' );
            }
        }
    }

    /*
        Function "_resetOpts"
        Called when the user clicks the "all results" button : reset all filters
    */
    _resetOpts( event ) {

        this._currentURL = null;

        this._updateCountResult( this._totalRecipes );

        // Reset the parameter array
        this._paramsRecipes = {
            alcoholfree : null,
            flavors : [],
            seasons : [],
            chefs : [],
            products : []
        }

        // Deselect all filters (input checkbox)
        for( let i = 0, j = this.views.inputsFilter.length; i < j; i++ ) {
            let element = this.views.inputsFilter[i];
            element.checked = false;
        }

        // Removes all created options based on the selected filters
        for( let i = 0, j = this.views.selectFilterOptsSelected .length; i < j; i++ ) {
            let element = this.views.selectFilterOptsSelected [i];
            element.innerHTML = '';
            element.classList.remove( 'show' );
        }
    }

    /*
        Function "_resetURL"
        Get the root of the url of the page
    */
    _resetURL() {
        this._currentURL = window.location.href.split('?')[0];
    }

    /*
        Function "_deleteFilters"
        Called when the user clicks on an option created according to the selected filters (the preview of checkbox seletected) : we delete the filter concerned
    */
    _deleteFilters( event ) {
        let target = event.delegateTarget;
        let parentTarget = target.parentNode;
        let nameFilter = parentTarget.getAttribute( 'data-name' );
        let valueFilter = parseInt( parentTarget.getAttribute( 'data-value' ) );

        if( this._paramsRecipes.hasOwnProperty( nameFilter ) ) {

            if ( Array.isArray( this._paramsRecipes[ nameFilter ] ) ) {

                let indexValue = this._paramsRecipes[ nameFilter ].indexOf( valueFilter );

                if( ( indexValue != -1 ) ) {

                    this._paramsRecipes[ nameFilter ].splice(indexValue, 1);

                    this._setStateFilter( nameFilter, valueFilter, false, true, true );
                }
            }
        }
    }

    /*
       Function "_resetContainerOptsSelected"
       Reset container who contains all filter selected if it is empty
       @Params :
            containerOptsSelected: element => container of selected filters
   */
    _resetContainerOptsSelected( containerOptsSelected ) {

        if( containerOptsSelected.innerHTML == '' )
            containerOptsSelected.classList.remove( 'show' );
    }

    /*
        Function "_closeFilterSelect"
        Called when the user clicks anywhere in the popin outside the filter list : we close the current filter list open
    */
    _closeFilterSelect( event ) {

        if( this._filterSelectIsOpen == true ) {

            if( !closest( event.target, '.js-choice-title' ) && !closest( event.target, '.js-choice-select-list' ) ) {

                for( let i = 0, j = this.views.selectFilter.length; i < j; i++ ) {

                    let element = this.views.selectFilter[i];
                    element.classList.remove('show');

                    this._filterSelectIsOpen = false;
                    this._containerFilterOptsSelected = null;
                }
            }
        }
    }

    /*
        Function "_getParamsUrl"
        Called to initialize the page : if the url contains filters, we preselect them in the filter popin
    */
    _getParamsUrl() {

        let urlPage = window.location.href;
        let paramsPage = urlPage.split( '?' )[1];

        if( paramsPage ) {
            let paramsBreak = this._parse_query_string( paramsPage );

            for (let param in paramsBreak) {

                if ( !paramsBreak.hasOwnProperty( param ) ) continue;

                if( param.indexOf( '[]' ) != -1 ) {

                    let nameFilter = param.split( '[]' )[0];

                    if( this._paramsRecipes.hasOwnProperty( nameFilter ) ) {

                        let filter = paramsBreak[ param ];

                        if ( Array.isArray( filter ) ) {
                            for ( let value in filter ) {
                                this._paramsRecipes[nameFilter].push( parseInt( filter[value] ) );
                                this._setStateFilter( nameFilter, filter[value], true, true, false );
                            }
                        } else {
                            this._paramsRecipes[ nameFilter ].push( parseInt( filter ) );
                            this._setStateFilter( nameFilter, filter, true, true, false );
                        }
                    }

                } else {

                    if( this._paramsRecipes.hasOwnProperty( param ) ) {
                        this._paramsRecipes[ param ] = true;
                        this._setStateFilter( param, 1, true, false, false );
                    }
                }
            }
        }
    }

    /*
        Function "_setStateFilter"
        Call when the state of a filter (input checkbox) changes
        @Params :
            nameFilter: string => name of the current filter,
            valueFilter: string / number => value the current filter,
            valueChecked: boolean => is the filter checked ?
            belongToList: boolean => does the filter belong to a list ?
            triggerEventChange: boolean => should we trigger the "change" event on the filter ?

    */
    _setStateFilter( nameFilter, valueFilter , valueChecked, belongToList = false, triggerEventChange = false ) {
        let checkboxFilter = this._container.querySelector('.js-input-filter[name="' + nameFilter + '"][value="' + valueFilter + '"]');
        checkboxFilter.checked = valueChecked;

        if( belongToList ) {
            let parentElement = checkboxFilter.parentNode.parentNode;
            let index = this.views.selectFilterList.indexOf( parentElement );
            this._containerFilterOptsSelected = this.views.selectFilterOptsSelected[ index ];

            if( valueChecked )
                this._addOptsSelected( checkboxFilter.getAttribute( 'data-label' ), checkboxFilter.name, checkboxFilter.value );
            else
                this._removeOptsSelected( checkboxFilter.name, checkboxFilter.value );
        }

        if( triggerEventChange ) {

            let event;
            if(typeof(Event) === 'function') {
                event = new Event('change');
            }else{
                event = document.createEvent('Event');
                event.initEvent('change', true, true);
            }

            checkboxFilter.dispatchEvent(event);
        }
    }

    /*
       Function "_addOptsSelected"
       Called when the user selects a filter (input checkbox): adds the element corresponding to the checked filter.
       @Params :
            label: string => label of the checked filter
            name: string => name of the checked filter
            value: number => value of the checked filter
   */
    _addOptsSelected( label, name, value ) {

        if( this._containerFilterOptsSelected != null ) {

            this._containerFilterOptsSelected.classList.add( 'show' );

            let element = '<div class="choice-options-item js-choice-options-item font-13" data-name="' + name + '" data-value="' + value + '">';
            element += label;
            element += '<span class="choice-options-delete js-options-delete"></span>';
            element += '</div>';

            this._containerFilterOptsSelected.insertAdjacentHTML('beforeend', element);
        }
    }

    /*
       Function "_removeOptsSelected"
       Called when the user deselects a filter (input checkbox): deletes the element corresponding to the unchecked filter
       @Params :
            name: string => name of the unchecked filter
            value: number => value of the unchecked filter
    */
    _removeOptsSelected( name, value ) {
        let optSelected = this._container.querySelector('.js-choice-options-item[data-name="' + name + '"][data-value="' + value + '"]');
        let parentTarget = optSelected.parentNode;

        if ( !( 'remove' in Element.prototype ) ) {
            parentTarget.removeChild( optSelected )
        } else {
            optSelected.remove();
        }

        this._resetContainerOptsSelected( parentTarget );
    }

    /*
       Function "_parse_query_string"
       Get all the parameters contained in a url
       @return : all params URL in array
   */
    _parse_query_string(query) {

        let vars = query.split("&");

        let query_string = {};

        for (let i = 0; i < vars.length; i++) {

            let pair = vars[i].split("=");
            let key = decodeURIComponent(pair[0]);
            let value = decodeURIComponent(pair[1]);

            // If first entry with this name
            if (typeof query_string[key] === "undefined") {
                query_string[key] = decodeURIComponent(value);
                // If second entry with this name
            } else if (typeof query_string[key] === "string") {
                let arr = [query_string[key], decodeURIComponent(value)];
                query_string[key] = arr;
                // If third or later entry with this name
            } else {
                query_string[key].push(decodeURIComponent(value));
            }
        }

        return query_string;
    }
}

export const MANAGE_POPIN_FILTER_EVENT = {
    'CLOSE' : '__mpf_close',
    'OPEN' : '__mpf_open'
}



// WEBPACK FOOTER //
// ./src/js/pages/recipes/popin-filter/popin-filter.js